import dayjs from 'dayjs';

import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import fromNow from 'dayjs/plugin/relativeTime';
import strict from './strict-date/strict';
import i18n from '@/i18n';

// English is the default locale in dayjs and other locales must be included additionally
require('dayjs/locale/nb');
dayjs.locale(i18n.locale); // sets dayjs' locale synchronized to i18n

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(fromNow);
dayjs.extend(customParseFormat);
dayjs.extend(strict);

export default dayjs;
